"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

/**
A function that determines whether an element is focusable or not.
@param {Element} element - The element to be checked.
@param {boolean} isTabIndexNotNaN - A boolean value indicating whether the tabIndex attribute is not NaN.
@returns {boolean} - Returns true if the element is focusable, false otherwise.
*/
function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  if (/input|select|textarea|button|object/.test(nodeName)) {
    return !element.disabled;
    // eslint-disable-next-line no-else-return
  } else if (nodeName === 'a') {
    return element.href || isTabIndexNotNaN;
  }
  return isTabIndexNotNaN;
}

/**
A function that determines whether an element is tabbable or not.
@param {Element} element - The element to be checked.
@returns {boolean} - Returns true if the element is tabbable, false otherwise.
*/
function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

/**
A function that finds all tabbable descendants of a given element.
@param {Element} element - The element to search for tabbable descendants.
@returns {Array} - Returns an array of tabbable descendants.
*/
function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function (el) {
    return tabbable(el);
  });
}
var _default = exports["default"] = findTabbableDescendants;
//# sourceMappingURL=tabbable.js.map